let previousPage: string | null = null;

export const navigationTracker = {
  setCurrentPage: (currentPath: string) => {
    if (previousPage !== currentPath) {
      previousPage = currentPath;
    }
  },

  getPreviousPage: () => previousPage,

  setPreviousPage: (path: string | null) => {
    previousPage = path;
  },
};
